import { React, useEffect } from "react";
import { Button, Form, Input } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { HaberForm, RightDrawerContainer } from "../../styledElements";
import RightDrawerSidebar from "../../../Components/RightDrawer/rightDrawer";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertBlue from "../../../Assets/Icons/alertGreen.svg";
import { DisabledStyles } from "../../pageStyled";
import { bulkChangeOrderState } from "../../../Services/orderServices";

const { TextArea } = Input;

const ActionDrawer = ({
  visible,
  onClose,
  onCloseGrade,
  orderNo,
  type,
  reFetch,
  setActionResponse,
  showToaster,
  children,
}) => {
  const [form] = Form.useForm();

  const rejectOrder = (orderNo, reason) => {
    bulkChangeOrderState([
      {
        order: orderNo,
        state: "rejected",
        comment: reason,
      },
    ])
      .then((response) => {
        setActionResponse({ error: response.error, msg: response.msg });
        onCloseGrade();
        reFetch(true);
        showToaster();
      })
      .catch((error) => {
        setActionResponse({
          error: error.response.data.error,
          msg: error.response.data.msg,
        });
        // console.log("reject error", error.response);
      });
  };

  const requestChanges = (orderNo, reason) => {
    bulkChangeOrderState([
      {
        order: orderNo,
        state: "review",
        comment: reason,
      },
    ])
      .then((response) => {
        setActionResponse({ error: response.error, msg: response.msg });
        onCloseGrade();
        reFetch(true);
        showToaster();
      })
      .catch((error) => {
        setActionResponse({
          error: error.response.data.error,
          msg: error.response.data.msg,
        });
        // console.log("reject error", error.response);
      });
  };

  const holdOrder = (orderNo, reason) => {
    bulkChangeOrderState([
      {
        order: orderNo,
        state: "hold",
        comment: reason,
      },
    ])
      .then((response) => {
        setActionResponse({ error: response.error, msg: response.msg });
        onCloseGrade();
        reFetch(true);
        showToaster();
      })
      .catch((error) => {
        setActionResponse({
          error: error.response.data.error,
          msg: error.response.data.msg,
        });
        // console.log("reject error", error.response);
      });
  };

  const cancelOrder = (orderNo, reason) => {
    bulkChangeOrderState([
      {
        order: orderNo,
        state: "cancel",
        comment: reason,
      },
    ])
      .then((response) => {
        setActionResponse({ error: response.error, msg: !response.error ? "Order " + orderNo + " has been successfully cancelled" : response.msg });
        onCloseGrade();
        reFetch(true);
        showToaster();
      })
      .catch((error) => {
        setActionResponse({
          error: error.response.data.error,
          msg: error.response.data.msg,
        });
        onCloseGrade();
        reFetch(true);
        showToaster();
        // console.log("reject error", error.response);
      });
  };

  const onFinish = (e) => {
    // console.log(e);
    type === "reject"
      ? rejectOrder(e.orderNo, e.reason)
      : type === "change"
      ? requestChanges(e.orderNo, e.reason)
      : type === "hold"
      ? holdOrder(e.orderNo, e.reason)
      : type === "cancel" && cancelOrder(e.orderNo, e.reason);
    // : null
  };

  useEffect(() => {
    form.resetFields();
  }, [orderNo]);

  return (
    <RightDrawerSidebar
      title={
        type === "reject"
          ? "Reject Order"
          : type === "change"
          ? "Request Changes"
          : type === "hold"
          ? "Hold Order"
          : type === "cancel"
          ? "Cancel Order"
          : ""
      }
      subtitle=""
      visible={visible}
      onClose={onCloseGrade}
    >
      <RightDrawerContainer>
        <div className="resetPassForm removePadLeft">
          <HaberForm>
            <Form
              name="basic"
              form={form}
              autoComplete="off"
              className="haberLogin haberSignup"
              style={{ marginTop: "0" }}
              onFinish={onFinish}
            >
              <div className="drawerField">
                <div className="titleWithText">
                  <h5>Order Code</h5>
                  <p>A unique auto-generated code to identify order</p>
                </div>

                <DisabledStyles>
                  <Form.Item
                    name="orderNo"
                    rules={[{ required: true }]}
                    initialValue={orderNo}
                  >
                    <Input disabled={true} className="requestChangeValue" />
                  </Form.Item>
                </DisabledStyles>
              </div>

              <div className="drawerField">
                <div className="titleWithText">{children}</div>
                <Form.Item
                  name="reason"
                  rules={[{ required: true }]}
                  className=""
                >
                  <TextArea
                    maxLength={100}
                    style={{ height: 90 }}
                    placeholder={`Mention the ${
                      type === "reject" || type === "hold" || type === "cancel"
                        ? "reason"
                        : type === "change"
                        ? "changes"
                        : ""
                    } here`}
                  />
                </Form.Item>
              </div>
              <div className="buttonFlex fixedBtm">
                <Form.Item>
                  {type === "reject" ? (
                    <Button htmlType="submit" className="themeBtn">
                      <Iconmoon icon="wrong-file" size={16} color="#ffffff" />
                      Reject Order
                    </Button>
                  ) : type === "change" ? (
                    <Button htmlType="submit" className="themeBtn">
                      <Iconmoon icon="wrong" size={16} color="#ffffff" />
                      Request Changes
                    </Button>
                  ) : type === "hold" ? (
                    <Button htmlType="submit" className="themeBtn">
                      <Iconmoon icon="wrong" size={16} color="#ffffff" /> Hold
                    </Button>
                  ) : type === "cancel" ? (
                    <Button htmlType="submit" className="themeBtn">
                      <Iconmoon icon="wrong" size={16} color="#ffffff" /> Cancel Order
                    </Button>
                  ) : null}
                </Form.Item>
              </div>
            </Form>
          </HaberForm>
        </div>
        {type === "reject" && (
          <AlertContainer
            color="yellow btmFix"
            icon={alertBlue}
            msg="Once an order is rejected, it cannot be modified or approved later."
          />
        )}
      </RightDrawerContainer>
    </RightDrawerSidebar>
  );
};

export default ActionDrawer;
